<template>
    <div ref="choose_market" class="choose-market">
        <h2 class="mb-3">{{ $t('market_ChooseMarket') }}</h2>
        <p>{{ $t('chooseMarket') }}</p>
        <div class="markets-container">
            <div @click="setCurrentMarket('Forex'), setNextBtnDisabled(false)"
                :class="'market-card forex-test ' + (currentMarket == 'Forex' ? 'selected' : '')">
                <p>{{ $t('forexTest') }}</p>
                <div class="market-bubble market-avaible" style="z-index: 5;">
                    <img width="50" src="https://tradingfunder.com/wp-content/uploads/2022/01/FTMO-logo.png "
                         alt="logo">
                </div>
                <div class="market-bubble market-avaible" style="z-index: 4;">
                    <img width="50" src="https://hub.swiset.com/wp-content/uploads/2022/10/Impulse-World-Pro.png"
                         alt="logo">
                </div>
                <div class="market-bubble market-more">
                    +9
                </div>
            </div>
            <div @click="setCurrentMarket('Futures'), setNextBtnDisabled(false)"
                :class="'market-card futures-test ' + (currentMarket == 'Futures' ? 'selected' : '')">
                <p>{{ $t('futuresTest') }}</p>
                <div class="market-bubble market-avaible" style="z-index: 5;">
                    <img width="50"
                        src="https://www.modestmoney.com/wp-content/uploads/2021/04/Logo_Outlines-Black-Large-R-.png"
                        alt="logo">
                </div>
                <div class="market-bubble market-avaible" style="z-index: 4;">
                    <img width="50" src="https://hub.swiset.com/wp-content/uploads/2022/10/The-Trading-Pit.png" alt="logo">
                </div>
                <div class="market-bubble market-more">
                    +4
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        currentMarket: String,
        stepActive: Boolean,
        setCurrentMarket: Function,
        setNextBtnDisabled: Function
    },
    watch: {
        stepActive: function () {
            if (this.stepActive) {
                this.$refs.choose_market.style.width = "100%";
                this.$refs.choose_market.style.height = "0%";
                if (this.currentMarket) {
                    this.setNextBtnDisabled(false);
                }
                return;
            }
            this.$refs.choose_market.style.width = "0";
            this.$refs.choose_market.style.height = "0";
        }
    },
    data: function () {
        return {
            loading: false,
        }
    },
    methods: {

    }
}
</script>

<style lang="scss">
.theme--dark {
    .choose-market {
        .markets-container {
            .market-card {
                background-color: #303740;
            }
        }
    }
}

.choose-market {
    width: 100%;
    display: flex;
    flex-direction: column;
    transition: width 0.09s ease-in-out;
    overflow: hidden;

    h6 {
        font-size: 32px;
        font-weight: bold;
        margin-bottom: 10px;
        font-family: "Avenir", sans-serif;
    }

    p {
        font-size: 16px;
        margin-bottom: 40px;
        font-family: "Avenir", sans-serif;
    }

    .markets-container {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;

        @media (max-width:1326px) {
            justify-content: center
        }

        .market-card {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 31px 34px;
            min-width: 453px;
            background: #fff;
            border-radius: 10px;
            border: 1px solid transparent;
            box-shadow: 5px 5px 20px 0 rgba(0, 0, 0, 0.05);
            transition: box-shadow 0.15s ease-in-out;
            transition: border 0.15s ease-in-out;

            p {
                margin: 0;
            }

            .market-bubble {
                width: 65px;
                height: 65px;
                font-size: 18px;
                font-family: "Avenir", sans-serif;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                border: 2px solid var(--v-cardBackground-base);
                background: #EEEEEE;
                border-radius: 100px;

                &:not(:first-child) {
                    margin-right: -160px;
                }

                &.market-more {
                    margin-left: 0;
                    margin-right: 0;
                    color: black;
                    font-weight: bold;
                }
            }

            &:hover {
                border: 1px solid #9A9A9A;
                box-shadow: none;
                cursor: pointer;
            }

            &.selected {
                border: 1px solid var(--v-mainGreen-base);
                cursor: pointer;
                box-shadow: none;
            }

            margin-right: 20px;

            &:last-of-type {
                margin-left: 20px;
                margin-right: 0;
            }

            @media (max-width:1326px) {
                margin-bottom: 20px;
                margin-right: 0;
                margin-left: 0;
                width: 100%;
                min-width: unset;
                &:last-of-type {
                    margin-left: 0;
                    margin-top: 20px;
                    margin-bottom: 0;
                }
            }
        }
    }
}
</style>